import React from 'react';
import { withTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import AboutDataProtection from '../Elements/AboutDataProtection';
import WhatWeDoDataProtection from '../Elements/WhatWeDoDataProtection';
import AchievementsDataProtection from '../Elements/AchievementsDataProtection';


var bnrimg = require('../../images/banner/5.jpg');

class About1 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/custom.js');

    };
    render() {
        const { t } = this.props;
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title={t('pages.dataProtection.banner.title')} pagename={t('pages.dataProtection.banner.pagename')} description={t('pages.dataProtection.banner.description')} bgimage={bnrimg}/>
                    <AboutDataProtection />
                    <WhatWeDoDataProtection />
                    <AchievementsDataProtection />
                </div>

                <Footer />
            </>
        );
    };
};

export default withTranslation()(About1);